export type PillColor = 'green' | 'orange' | 'orangered' | 'red' | 'gray' | 'arcoblue' | 'blue' | 'purple' | 'gold' | 'cyan';

/**
 * 通用状态胶囊（深空统一口径，design-spec §4）：
 * 与 StatusTag 同视觉语言，但颜色显式指定（StatusTag 按 value 自动映射）。
 * 用于页面内直接 `<Tag color="x">` 的状态/类型标签替换；AI 语义元素请用 AiBadge。
 * 注：cyan=电光青（AI/场景语义，--pill-cyan token）。
 * size="sm" 走 .bcc-pill-sm（高 20 / 字号 11）、size="xs" 走 .bcc-pill-xs（高 18 / 字号 11），
 * 替代页面内联 style 尺寸覆盖。
 */
export default function PillTag({
  color = 'arcoblue',
  size,
  children,
  style,
  title,
}: {
  color?: PillColor;
  /** 尺寸变体：sm=密集行/表格内小号胶囊（默认 22px 高）；xs=多标签堆叠行（如工作台服务记录）更紧凑 */
  size?: 'sm' | 'xs';
  children?: React.ReactNode;
  style?: React.CSSProperties;
  title?: string;
}) {
  const cls = `bcc-pill bcc-pill-${color}${size ? ` bcc-pill-${size}` : ''}`;
  return (
    <span className={cls} style={style} title={title}>
      {children}
    </span>
  );
}
